import { render, staticRenderFns } from "./ItemHeading.vue?vue&type=template&id=718e13ae&scoped=true"
import script from "./ItemHeading.vue?vue&type=script&lang=js"
export * from "./ItemHeading.vue?vue&type=script&lang=js"
import style0 from "./ItemHeading.vue?vue&type=style&index=0&id=718e13ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e13ae",
  null
  
)

export default component.exports